import { Action } from 'redux';

import { IContentInfo } from '../../ts/models/IContentInfo';
import { isActionFactory } from '../../app/actions/isActionFactory';

export const NewMetricForDatasource = 'NewMetricForDatasource';

export interface NewMetricForDatasourceAction extends Action {
  contentInfo: IContentInfo;
}

export function newMetricForDatasource(contentInfo: IContentInfo): NewMetricForDatasourceAction {
  return {
    type: NewMetricForDatasource,
    contentInfo
  };
}

export const isNewMetricForDatasourceAction = isActionFactory<NewMetricForDatasourceAction>(NewMetricForDatasource);
